import { render, staticRenderFns } from "./ElXlsx.vue?vue&type=template&id=d749d2b2&"
import script from "./ElXlsx.vue?vue&type=script&lang=js&"
export * from "./ElXlsx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports